/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';

// components
import { Grid } from '@design-system-coopeuch/web';

// assets
import { StyledWrapperButtons, StyledButton } from './styles';
import iconStart from '../../../assets/img/icon-start.svg';

// COMMENT: step: initial, middle, end (para indicar en que paso estamos y ver que boton mostrar)
const FlowControlButtons = (props) => {
  const {
    nameButtonContinue,
    nameButtonMiddle = '',
    nameButtonBackExit = '',
    canContinue,
    haveAppearanceDisabled,
    step,
    onContinueFlow,
    onContinueMiddleFlow,
    onCancelFlow,
    onReturnMainPage,
    onCallSurvey,
    prefixContinue,
  } = props;

  const propsToStyledButton = {
    variant: '',
    onClick: onContinueFlow,
    prefix: prefixContinue || '',
    ...(haveAppearanceDisabled ? { appearanceDisabled: !canContinue } : { disabled: !canContinue }),
  };

  return (
    <StyledWrapperButtons data-testid="flow-control-buttons" className={step === 'end' ? 'mt-0' : 'mt-0'}>
      {(step === 'initial' || step === 'middle') && (
        <>
          <Grid col={12} md={8} className="p-0 d-flex flex-column flex-md-row justify-content-end">
            {nameButtonMiddle && (
              <StyledButton
                variant="outline"
                className="mr-0 mr-md-4 mb-2 mb-md-0 w-100 width-md-auto"
                onClick={onContinueMiddleFlow}
              >
                {nameButtonMiddle}
              </StyledButton>
            )}
            <StyledButton {...propsToStyledButton} className="mb-1 mb-md-0 w-100 width-md-auto">
              {nameButtonContinue || 'Continuar'}
            </StyledButton>
          </Grid>
          <Grid col={12} md={3} className="p-0 d-flex">
            <StyledButton variant="text" onClick={onCancelFlow}>
              {nameButtonBackExit || 'Cancelar'}
            </StyledButton>
          </Grid>
        </>
      )}
      {step === 'end' && (
        <Grid col={12} className="p-0 d-flex justify-content-start">
          <StyledButton variant="text" prefix="old-arrow-left" onClick={onReturnMainPage}>
            Volver a Coopeuch.cl
          </StyledButton>
          <button
            type="button"
            onClick={() => onCallSurvey()}
            className="btn-without-format--red-underline d-flex justify-content-center align-items-center text-decoration-none font-size-14"
          >
            <img className="mr-1" src={iconStart} width={20} alt="" />
            Danos tu opinión
          </button>
        </Grid>
      )}
    </StyledWrapperButtons>
  );
};
/* istanbul ignore next */
FlowControlButtons.defaultProps = {
  nameButtonContinue: '',
  canContinue: false,
  haveAppearanceDisabled: false,
  step: '',
  prefixContinue: '',
  onContinueFlow: () => null,
  onCancelFlow: () => null,
  onReturnMainPage: () => null,
  onCallSurvey: () => null,
};

FlowControlButtons.propTypes = {
  nameButtonContinue: PropTypes.string,
  canContinue: PropTypes.bool,
  haveAppearanceDisabled: PropTypes.bool,
  step: PropTypes.string,
  prefixContinue: PropTypes.string,
  onContinueFlow: PropTypes.func,
  onCancelFlow: PropTypes.func,
  onReturnMainPage: PropTypes.func,
  onCallSurvey: PropTypes.func,
};

export default FlowControlButtons;
